import type { FaireProductEntity } from "../../entity_types/product";

export const p_zujh3xvyde: FaireProductEntity = {
  token: "p_zujh3xvyde",
  type: "product",
  name: "Rug Campo",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d15ff1dde20e74287f7b5d7faba9edfa71c35965633d4936b835d79ba1bd6dd7.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/af5274b213652bdbc4e877fc276e9aae4a3ca59d9598c029b090f303b4bd4df1.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
